angular.module("userInfoResult.components", []).component("userInfoResult", {
  templateUrl:
    "ng/components/userManagementAra/userInfoResult/userInfoResult.html",
  bindings: {
    configObj: "<",
  },
  controller: userInfoResultController,
  controllerAs: "userInfoCtrl",
});

function userInfoResultController(
  $searchUserService,
  $modalService
) {
  var self = this;

  self.updatedUserInfo = {
    email: null,
    tel: null,
    name: null,
    surname: null,
    identifier: null,
    bankCode: null,
    idUser: null,
  };

  self.$onInit = function () {
    self.modifyInfo = false;
  };

  self.impersonifica = function () {
    $modalService.openModal("modal-impersonifica");
  };

  self.enableModify = function () {
    self.updatedUserInfo.name = self.configObj.appUser.name;
    self.updatedUserInfo.surname = self.configObj.appUser.surname;
    self.updatedUserInfo.email =
      self.configObj.appUser.email || self.configObj.appUser.emailNsil;
    self.updatedUserInfo.tel = self.configObj.appUser.tel;
    self.modifyInfo = true;
  };

  self.updateInfo = function () {
    self.updatedUserInfo.identifier = self.configObj.appUser.identifier;
    self.updatedUserInfo.bankCode = self.configObj.appUser.bankCode;
    self.updatedUserInfo.idUser = self.configObj.appUser.idUser;
    self.modifyInfo = false;
    self.isSaving = true;
    $searchUserService
      .updateAppUser(self.updatedUserInfo)
      .then(function (response) {
        if (response.success) {
          self.modifyInfo = false;
          self.configObj.appUser.tel = self.updatedUserInfo.tel;
          self.configObj.appUser.name = self.updatedUserInfo.name;
          self.configObj.appUser.surname = self.updatedUserInfo.surname;
          self.configObj.appUser.email = self.updatedUserInfo.email;
        }
        self.isSaving = false;
      })
      .catch(function (err) {
        console.log(err);
        self.isSaving = false;
      })
      .finally(function () {
        self.isSaving = false;
      });
  };

  self.cancelChanges = function () {
    self.modifyInfo = false;
  };
}